import { render, staticRenderFns } from "./UrunSepetAracKira.vue?vue&type=template&id=774afa62&scoped=true"
import script from "./UrunSepetAracKira.vue?vue&type=script&lang=js"
export * from "./UrunSepetAracKira.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774afa62",
  null
  
)

export default component.exports